import { Sparkles } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="qn-seccion qn-rsvp" aria-label={seccion.titulo}>
      <div className="qn-seccion-interior">
        <EncabezadoSeccion p="qn" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="qn-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="qn-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="qn-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="qn-boton qn-boton--lleno"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="qn-boton-rsvp"
          >
            <Sparkles strokeWidth={1.5} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
